import { CreateNS } from '../lib/createAPIBuilder';

export const installAPIOptimizely = (namespace: CreateNS) => {
    namespace('experiment')(({ func, deps }) => {
        func(
            'getVariationAnonymous',
            deps.optimizely.getVariationAnonymousOptimizely,
        );
        func(
            'addNotificationListener',
            deps.optimizely.addNotificationListener,
        );
        func(
            'removeNotificationListener',
            deps.optimizely.removeNotificationListener,
        );
        func(
            'getVariationAuthenticated',
            deps.optimizely.getVariationAuthenticatedOptimizely,
        );
        func(
            'getForcedVariationAnonymous',
            deps.optimizely.getForcedVariationAnonymousOptimizely,
        );
        func(
            'getForcedVariationAuthenticated',
            deps.optimizely.getForcedVariationAuthenticatedOptimizely,
        );
        func(
            'setForcedVariationAnonymous',
            deps.optimizely.setForcedVariationAnonymousOptimizely,
        );
        func(
            'setForcedVariationAuthenticated',
            deps.optimizely.setForcedVariationAuthenticatedOptimizely,
        );
        func('trackAnonymous', deps.optimizely.trackAnonymousOptimizely);
        func(
            'trackAuthenticated',
            deps.optimizely.trackAuthenticatedOptimizely,
        );
        func('activateAnonymous', deps.optimizely.activateAnonymousOptimizely);
        func(
            'activateAuthenticated',
            deps.optimizely.activateAuthenticatedOptimizely,
        );
    });

    namespace('features')(({ func, deps }) => {
        func(
            'isEnabledAnonymous',
            deps.optimizely.isEnabledAnonymousOptimizely,
        );
        func(
            'isEnabledAuthenticated',
            deps.optimizely.isEnabledAuthenticatedOptimizely,
        );
        func(
            'getVariableBooleanAnonymous',
            deps.optimizely.getVariableBooleanAnonymousOptimizely,
        );
        func(
            'getVariableBooleanAuthenticated',
            deps.optimizely.getVariableBooleanAuthenticatedOptimizely,
        );
        func(
            'getVariableIntegerAnonymous',
            deps.optimizely.getVariableIntegerAnonymousOptimizely,
        );
        func(
            'getVariableIntegerAuthenticated',
            deps.optimizely.getVariableIntegerAuthenticatedOptimizely,
        );
        func(
            'getVariableStringAnonymous',
            deps.optimizely.getVariableStringAnonymousOptimizely,
        );
        func(
            'getVariableStringAuthenticated',
            deps.optimizely.getVariableStringAuthenticatedOptimizely,
        );

        func(
            'getVariableObjectAnonymous',
            deps.featurevisor.getVariableObjectAnonymous,
        );
        func(
            'getVariableArrayAnonymous',
            deps.featurevisor.getVariableArrayAnonymous,
        );
        func(
            'getVariableArrayAuthenticated',
            deps.featurevisor.getVariableArrayAuthenticated,
        );
        func(
            'getVariableObjectAuthenticated',
            deps.featurevisor.getVariableObjectAuthenticated,
        );
    });
};
